import React, { Component } from 'react';
import ChartHolder          from './visualization/chart-holder';
import TableHolder          from './visualization/table-holder';
import Spinner              from './generic/spinner';
import Parse                from 'parse';
import Utils                from '../Utils/Utility';
import Api                  from '../Utils/api';
import _                    from 'lodash';
import moment               from 'moment-timezone';
import DateRangePickerFilter from "./visualization/date-range2";

const columns = {
    'date'           : {type : 'string',label : 'Date'},
    'subTotal'       : {type : 'number',label : 'Sub Total'},
    'total'          : {type : 'number',label : 'Total'},
    'paidAmount'     : {type : 'number',label : 'Paid Amount'},
    'platformCharge' : {type : 'number',label : 'Platform Charge'},
    'orderType'      : {type : 'string',label : 'Order Type'},
    'count'          : {type : 'number',label : 'Count'},
    'deliveryFee'    : {type : 'number',label : 'Delivery Fee'},
    'taxes'          : {type : 'number',label : 'Taxes'}

};

export default class Stats extends Component{

    static contextTypes = {
        router: React.PropTypes.object.isRequired
    };

    constructor(props){
        super(props);

        this.state={
            chartOrderData      : {},
            chartSalesData      : {},
            tableOrderStatsData : [],
            colFormatters       : [],
            fromDate            : this.setLocationTimeZoneInMoment(),
            toDate              : this.setLocationTimeZoneInMoment(),
            isLoaded            : true,
            timeZone            : null,
            activeLocation      : null,
            showOrderStats      : false
        };

        this._bind(
            'onDateSelectionChanged',
            'fetchOrderStatsData',
            'generateChartHolderComponent',
            'setLocationTimeZoneInMoment'
        );

    }

    _bind(...methods) {
      methods.forEach( (method) => this[method] = this[method].bind(this) );
     }


    /*  Set default timezone on moment  */
    setLocationTimeZoneInMoment(){

        let timeZone = Utils.extractTimeZoneFromLocation(this.props.activeLocation);
        moment.tz.setDefault(timeZone);
        return moment();
    }
    initializeDateTime(){

        let self = this;

        let timeZone = this.state.timeZone;

        let currentDateTime = Utils.formatDateTimeWithTimeZone(new Date(), timeZone);

        let defaultFromDate = new Date(currentDateTime);
        let defaultToDate = new Date(currentDateTime);

        defaultFromDate.setDate(defaultFromDate.getDate() - 6);
        defaultFromDate.setHours(0, 0, 0, 0);

        defaultToDate.setHours(23, 59, 59, 0);


        this.setState({
            fromDate       : defaultFromDate,
            toDate         : defaultToDate,
            chartOrderData      : {},
            chartSalesData      : {},
            tableOrderStatsData : [],
            colFormatters       : [],
            showOrderStats: true
        },()=>{
            Utils.isUserSessionInvalid().then((response) => {
               // console.log("success user session: "+JSON.stringify(response));
                self.fetchOrderStatsData();
            }, (error) => {
              //  console.log("error user session: "+JSON.stringify(error));
                // user session is invalid
                Utils.checkErrorIsInvalidSessionToken(error, self.context.router);

            });


        });

    }

    componentDidMount() {

        let self = this;
        // if ((typeof google === 'undefined') || (typeof google.visualization === 'undefined')) {
        //
        // }
        // google.charts.load('current', {packages: ['corechart','table', 'bar']});

        self.initializeDateTime();
    }


    componentWillMount() {


        google.charts.load('current', {packages: ['corechart','table', 'bar']});

         let timeZone = Utils.extractTimeZoneFromLocation(this.props.activeLocation);

         this.setState({
             activeLocation : this.props.activeLocation,
             timeZone       : timeZone
         });
     }

     componentWillReceiveProps(nextProps) {
         // var google = google.charts.load('current', {packages: ['corechart','table', 'bar']});

         if(nextProps != null){
             this.setState({
                 activeLocation : nextProps.activeLocation,
                 timeZone       : Utils.extractTimeZoneFromLocation(nextProps.activeLocation)
             },
             () => {
                 this.initializeDateTime();
             });
         }
     }

     getColFormatters(){

         let currencyFormatter = new google.visualization.NumberFormat({prefix: '$'});

        return [
             {
                 colIndex  : 1,
                 formatter : currencyFormatter
             },
             {
                 colIndex  : 2,
                 formatter : currencyFormatter
             },
             {
                 colIndex  : 3,
                 formatter : currencyFormatter
             },
             {
                 colIndex  : 4,
                 formatter : currencyFormatter
             },
             {
                 colIndex  : 7,
                 formatter : currencyFormatter
             },
             {
                 colIndex  : 8,
                 formatter : currencyFormatter
             }
         ];

     }

     populateDummyChartData(chartObj, fromDate, toDate) {

         Object.keys(chartObj).forEach((date)=>{
             let data = chartObj[date];
             if (!("PickUp" in data)) {
                 data["PickUp"] = 0;
             }

             if (!("Delivery" in data)) {
                 data["Delivery"] = 0;
             }

             if (!("DineIn" in data)) {
                 data["DineIn"] = 0;
             }
         });

        if (fromDate.getTime() === toDate.getTime()) {
            toDate.setDate(toDate.getDate() + 1);
        }

        const fromDateStr = fromDate.toLocaleDateString();
        const toDateStr   = toDate.toLocaleDateString();


        if (!chartObj[fromDateStr]) {
            chartObj[fromDateStr] = { date : fromDate, PickUp : 0, Delivery : 0, DineIn : 0 };
        }

        if (!chartObj[toDateStr]) {
            chartObj[toDateStr] = { date : toDate, PickUp : 0, Delivery : 0, DineIn : 0 };
        }
        return chartObj;
     }

     // getDateString = (date) => {
     //     const timeZone     = this.state.timeZone;
     //     return moment.tz(date, timeZone).format("YYYY-MM-DD");
     // }

     fetchOrderStatsData() {

         let self = this;
         // self.setState({
         //     isLoaded : false
         // });

         let fromDate     = this.state.fromDate;
         let toDate       = this.state.toDate;
         let currentUser  = Parse.User.current();
         let userId       = currentUser.id;
         let sessionToken = currentUser.getSessionToken();
         let locId        = this.state.activeLocation.objectId;

        let fromUtcDate = new Date(Date.UTC(fromDate.getFullYear(),fromDate.getMonth(),fromDate.getDate()));
        let toUtcDate = new Date(Date.UTC(toDate.getFullYear(),toDate.getMonth(),toDate.getDate()));

         // console.log(fromUtcDate);
         // console.log(toUtcDate);

         // let fromDateTime =  moment(fromDate).format('YYYY-MM-DD');
         // let toDateTime =  moment(toDate).format('YYYY-MM-DD');

         let fromDateTime =  Utils.getDateString(fromDate, this.state.timeZone);
         let toDateTime =  Utils.getDateString(toDate, this.state.timeZone);

         const dateRange = {'tzStartDate': fromDateTime, 'tzEndDate': toDateTime};

         // console.log(JSON.stringify(dateRange));

         Api.getOrderStatsAt(
             userId, sessionToken, dateRange, locId
         ).then((response) => {
             if (response.data) {

                 const results = response.data;

                 let chartOrderData      = {};
                 let chartSalesData      = {};
                 let tableOrderStatsData = [];

                 results.forEach( result => {

                     let now          = new Date(result.date.iso);
                     let res          = result;
                     let orderDate    = new Date(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate());
                     let orderDateStr = new Date(res.date.iso).toLocaleDateString();
                     //let now          = result.get('date');
                     //let res          = result.toJSON();

                     //let tempDate = moment(now);
                     //let orderDate    = new Date(tempDate.format("MM/DD/YYYY"));
                     /*let orderDateStr = moment(now).format("MM/DD/YYYY");*/

                     //Order Type
                     let chartOrderObj={
                         date            : orderDate,
                         [res.orderType] : res.count
                     };
                     if (orderDateStr in chartOrderData) {
                         chartOrderData[orderDateStr] = _.merge(chartOrderData[orderDateStr], chartOrderObj);
                     } else {
                         chartOrderData[orderDateStr] = chartOrderObj;
                     }
                     // Paid Amount

                     // [res.orderType] : (res.paidAmount || 0)

                     let paidAmount = 0;
                     if (res.paidAmount) {
                         paidAmount = res.paidAmount;
                     }

                     let chartSalesObj = {
                         date            : orderDate,
                         [res.orderType] : paidAmount
                     };

                     if (orderDateStr in chartSalesData) {
                         chartSalesData[orderDateStr] = _.merge(chartSalesData[orderDateStr], chartSalesObj);
                     } else {
                         chartSalesData[orderDateStr] = chartSalesObj;
                     }
                     // OrderStats table
                     let tableRow = [];
                     Object.keys(columns).forEach(col => {
                         if(col === 'date'){
                             tableRow.push(orderDateStr);
                         }else{
                             tableRow.push(res[col]);
                         }
                     });
                     tableOrderStatsData.push(tableRow);
                 });
                 // console.log(JSON.stringify(tableOrderStatsData));
                 // console.log(JSON.stringify(chartOrderData));

                 chartOrderData = self.populateDummyChartData(chartOrderData, fromUtcDate, toUtcDate);
                 chartSalesData = self.populateDummyChartData(chartSalesData, fromUtcDate, toUtcDate);

                 // console.log(JSON.stringify(chartOrderData));

                 let colFormatters = self.getColFormatters();
                 self.setState({chartOrderData, chartSalesData, tableOrderStatsData, colFormatters, isLoaded : true});
             }
         }, (error) => {
             Utils.checkErrorIsInvalidSessionToken(error, self.context.router);
             self.setState({isLoaded : true});
             console.log("Error: " + JSON.stringify(error));
         });

     }


    //  genOrderStatsObjects(orderType){
    //      return {
    //      orderSubTotal       : 0,
    //      orderTotal          : 0,
    //      itemCountTotal      : 0,
    //      paidAmountTotal     : 0,
    //      platformChargeTotal : 0,
    //      deliveryFeeTotal    : 0,
    //      taxesTotal          : 0,
    //      locId               : '',
    //      orderType           : orderType
    //     }
    // }

    // populateOrderStatsObjects(obj,res){
    //
    //     obj.orderSubTotal       += res.subTotal;
    //     obj.orderTotal          += res.totalAmount;
    //     obj.itemCountTotal      += res.itemCount;
    //     obj.paidAmountTotal    += (res.paidAmount || 0);
    //     obj.platformChargeTotal += (res.platformCharge || 0);
    //     obj.deliveryFeeTotal    += (res.deliveryFee || 0);
    //     obj.taxesTotal          += (res.taxes || 0);
    //     obj.locId                = res.locationDetailPointer.objectId;
    //
    // }
    //
    // saveOrderStatsObjects(obj){
    //
    //     let OrderStats = Parse.Object.extend("OrderStats");
    //     let os         = new OrderStats();
    //     let date       = new Date();
    //
    //     date.setUTCHours(0, 0, 0, 0);
    //
    //     os.set("subTotal"       , Utils.round(obj.orderSubTotal,2));
    //     os.set("total"          , Utils.round(obj.orderTotal,2));
    //     os.set("platformCharge" , Utils.round(obj.platformChargeTotal,2));
    //     os.set("orderType"      , obj.orderType);
    //     os.set("date"           , date);
    //     os.set("count"          , obj.itemCountTotal);
    //     os.set("deliveryFee"    , Utils.round(obj.deliveryFeeTotal,2));
    //     os.set("paidAmount"     , Utils.round(obj.paidAmountTotal,2));
    //     os.set("taxes"          , Utils.round(obj.taxesTotal,2));
    //     os.set("locId"          , obj.locId);
    //
    //     return os.save();
    // }

    // getUTCFormattedDate(now){
    //     let date = new Date(now);
    //     date.setUTCHours(0, 0, 0, 0);
    //     return date;
    // }

    // checkNGenOrderStats(){
    //     Parse.Promise.enableAPlusCompliant();
    //
    //     if (!this.state.activeLocation) {
    //         return;
    //     }
    //
    //     let fromDate     = new Date(this.state.fromDate);
    //     let toDate       = new Date(this.state.toDate);
    //     let currentUser  = Parse.User.current();
    //     let locId        = this.state.activeLocation.objectId;
    //     let self         = this;
    //     let dateCheckObj = {};
    //
    //     fromDate.setHours(0, 0, 0, 0);
    //     toDate.setHours(0, 0, 0, 0);
    //
    //     while(fromDate<=toDate){
    //
    //         let d = new Date(fromDate);
    //         d.setUTCHours(24,0,0,0);
    //
    //         let key = d.toISOString();
    //         dateCheckObj[key]=false;
    //         fromDate.setHours(0, 0, 0, 0);
    //         fromDate.setDate(fromDate.getDate()+1);
    //     }
    //
    //     let OrderStats = Parse.Object.extend("OrderStats");
    //     let query      = new Parse.Query(OrderStats);
    //     let qFromDate  = new Date(this.state.fromDate);
    //     let qToDate    = new Date(this.state.toDate);
    //
    //     qFromDate.setUTCHours(24,0,0,0);
    //     qToDate.setUTCHours(24,0,0,0);
    //
    //     query.equalTo("locId",locId)
    //         .greaterThanOrEqualTo('date',qFromDate)
    //         .lessThanOrEqualTo('date',qToDate)
    //         .descending('date');
    //
    //     query.find().then(function(results){
    //         if(results.length !== 0){
    //             results.forEach(result =>{
    //                 let d = result.get('date').toISOString();
    //                 if(d in dateCheckObj){
    //                     dateCheckObj[d]=true;
    //                 }
    //             });
    //         }else{
    //             console.log('Record needs to be generated');
    //         }
    //         console.log(JSON.stringify(dateCheckObj));
    //     }).then(function(){
    //         let filteredDates = Object.keys(dateCheckObj).filter( date =>  !dateCheckObj[date]);
    //         console.log("Filtered Dates:"+filteredDates);
    //         return self.sendGenOrderStatRequest(filteredDates);
    //     }).then(function(){
    //         console.log('Successfully completed!');
    //     },
    //     function(error){
    //         console.log(JSON.stringify(error));
    //         console.log("Some error occured:"+error);
    //     });
    // }

    // sendGenOrderStatRequest(isoDates){
    //     let promises     = [];
    //     let currentUser  = Parse.User.current();
    //     let locId        = this.state.activeLocation.objectId;
    //     let userId       = currentUser.id;
    //     let sessionToken = currentUser.getSessionToken();
    //
    //     isoDates.forEach(isoDate => {
    //         promises.push(
    //             Api.getOrderStats(
    //                 userId, sessionToken, isoDate, locId
    //             )
    //         )
    //     });
    //
    //     return $.when.apply($, promises).done(()=>{ console.log("done"); });
    // }

    // genOrderStats() {
    //     let Order             = Parse.Object.extend("Order");
    //     let order             = new Order();
    //     let query             = new Parse.Query(Order);
    //     let self              = this;
    //
    //     let orderStatsColumns = [
    //         "createdAt","orderType","orderState","itemCount","charged","chargeId",
    //         "subTotal","taxes","deliveryFee","totalAmount","platformCharge","locationDetailPointer"
    //     ];
    //
    //     let date       = new Date();
    //     date.setUTCHours(0, 0, 0, 0);
    //
    //     // Select only required fields
    //     query.select(...orderStatsColumns);
    //
    //     query.greaterThanOrEqualTo('createdAt',date);
    //
    //     let deliveryObj = self.genOrderStatsObjects('Delivery');
    //     let pickupObj   = self.genOrderStatsObjects('PickUp');
    //
    //     query.each(
    //         function(result) {
    //         console.log(JSON.stringify(result));
    //
    //         let res      = result.toJSON();
    //         if(res.orderType === 'Delivery'){
    //             self.populateOrderStatsObjects(deliveryObj,res);
    //         }else{
    //             self.populateOrderStatsObjects(pickupObj,res);
    //         }
    //
    //         }).then(
    //         function(){
    //             let promises = [
    //                 self.saveOrderStatsObjects(deliveryObj),
    //                 self.saveOrderStatsObjects(pickupObj)
    //             ];
    //             return Parse.Promise.when(promises);
    //         }).then(
    //         function(){
    //             console.log('OrderStats row got created');
    //         },
    //         function(error){
    //             console.log("Error: "+error);
    //         });
    //
    // }

    onDateSelectionChanged(fromDate,toDate){

        this.setState({
            fromDate, toDate,
            isLoaded : false
        }, ()=>{
            this.fetchOrderStatsData();
        });


    }

    generateChartHolderComponentEmpty() {
        let component        = null;
        const chartOrderData = this.state.chartOrderData;
        const chartSalesData = this.state.chartSalesData;
        if(Utils.isEmptyObj(chartOrderData ) && Utils.isEmptyObj(chartSalesData)){
            component = (
                <ChartHolder
                    google         = {google}
                    chartOrderData = {chartOrderData }
                    chartSalesData = {chartSalesData}
                />
            );
        }
        return component;
    }

    generateChartHolderComponent() {
        let component        = null;
        const chartOrderData = this.state.chartOrderData;
        const chartSalesData = this.state.chartSalesData;
        if(!Utils.isEmptyObj(chartOrderData ) && !Utils.isEmptyObj(chartSalesData)){
             component = (
                 <ChartHolder
                     google         = {google}
                     chartOrderData = {this.state.chartOrderData}
                     chartSalesData = {this.state.chartSalesData}
                 />
            );
        }
        return component;
    }


    render() {
        return (
			<div className="trend-pg">
                { !this.state.isLoaded ? <Spinner/> : null }
                {
                    this.state.showOrderStats ? (
                        <div>
                            <div className="">
                                <div className="col-md-12 text-center">
                                    <label className="p-small">
                                        This page shows your order sales trend.
                                        <br/> It does not include Rejected orders.
                                        <br/> You can go back up to 60 days.
                                    </label>
                                </div>
                            </div>
                            {/*<div className="">*/}
                            {/*    <div className="col-md-10 text-center">*/}
                            {/*        <DateRangePicker*/}
                            {/*            defaultDateRangeDays={"100"}*/}
                            {/*            startDefaultFromDays={"6"}*/}
                            {/*            allowMinPastYear={"2"}*/}
                            {/*            timeZone = {this.state.timeZone}*/}
                            {/*            callBackParent={this.onDateSelectionChanged} */}
                            {/*        />*/}
                            {/*    </div>*/}
                            {/*</div>*/}
                            <div className="row ml-10">
                                <div className={"col-md-12 no-gutter ml-10"}>
                                    <DateRangePickerFilter
                                        className={"datepicker-container"}
                                        defaultDateRangeDays={"100"}
                                        startDefaultFromDays={"6"}
                                        allowMinPastYear={"2"}
                                        timeZone = {this.state.timeZone}
                                        callBackParent={this.onDateSelectionChanged}

                                    />

                                    <div className="col-md-3 no-gutter">
                                    </div>
                                </div>
                            </div>

                            <div className="">
                                <div className="col-md-12">
                                    {
                                        this.generateChartHolderComponentEmpty()
                                    }
                                    {
                                        this.generateChartHolderComponent()
                                    }
                                </div>
                            </div>
                            <div className="">
                                <div className="col-md-12">
                                    <p>Data Summary for <b>{Utils.getDateString(this.state.fromDate, this.state.timeZone)}</b> to <b>{Utils.getDateString(this.state.toDate, this.state.timeZone)}</b></p>
                                    <TableHolder
                                        google        = {google}
                                        columns       = {columns}
                                        tableData     = {this.state.tableOrderStatsData}
                                        colFormatters = {this.state.colFormatters}
                                    />
                                </div>
                            </div>
                        </div>

                    ) : null
                }
            </div>
        );
    }
}




// WEBPACK FOOTER //
// src/components/stats.js